/**
 * Consent categories used across the site. `necessary` is implicit and never
 * stored — it is always on, which is why it has no entry here.
 *
 * `analytics` → Google Analytics (GA4, through Google Tag Manager).
 * `ads`       → Google Ads conversions and RB2B visitor identification.
 *
 * Advertising and visitor identification share one category because the
 * privacy policy opts them out together (the "Do Not Sell or Share" link and
 * a GPC signal both clear exactly this pair).
 *
 * index.html reads the same cookie before Angular starts, to set the Google
 * Consent Mode default and to keep Google Tag Manager off after a full
 * rejection. Keep the cookie name and format in step with it.
 */
export interface ConsentState {
    analytics: boolean;
    ads: boolean;
}

export const CONSENT_COOKIE = 'atmavaan_consent';

/** Six months, the longest the cookie banner may go without re-asking. */
export const CONSENT_MAX_AGE_SECONDS = 15552000;

/**
 * The saved choice in a `document.cookie` string, or null when there is
 * none. Two flags in fixed order, analytics then ads; '-' means denied.
 */
export function parseConsentCookie(cookies: string): ConsentState | null {
    const match = cookies.match(new RegExp('(?:^|; )' + CONSENT_COOKIE + '=([^;]*)'));
    if (!match) return null;
    const value = decodeURIComponent(match[1]);
    if (value.length !== 2) return null;
    return { analytics: value[0] === 'a', ads: value[1] === 'x' };
}
